import { Grid, Stack, styled, Typography } from "@mui/material";
import { MprcClickable, MprcJoinComponents, MprcTypographyOnDemand } from "components";
import { JSX } from "react";

const MainContainer = styled("div")(
    ({ theme }) => ({
        height: "310px",
        width: "100%",
        minWidth: "716px",
        position: "relative",
        borderRadius: theme.spacing(2),
        boxShadow: "2px 2px 20px rgba(0, 0, 0, 0.2)"
    })
);

const BackgroundImage = styled(
    "div",
    { shouldForwardProp: (propName: string) => !["imageUrl"].includes(propName) }
)<{ imageUrl: string; }>(
    ({ theme, imageUrl }) => (
        {
            backgroundImage: `url("${imageUrl}")`,
            backgroundColor: "rgba(0, 0, 0, 0.3)",
            filter: "blur(40px)",
            WebkitFilter: "blur(40px)",
            height: "calc(100% - 8px)",
            width: "calc(100% - 8px)",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover"
        }
    )
);

const BackgroundThumbnail = styled(
    "div",
    { shouldForwardProp: (propName: string) => !["imageUrl"].includes(propName) }
)<{ imageUrl: string; }>(
    ({ theme, imageUrl }) => (
        {
            backgroundImage: `url("${imageUrl}")`,
            backgroundColor: "rgba(0, 0, 0)",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            borderRadius: "8px",
            position: "absolute",
            top: "100px",
            right: "16px",
            width: "220px",
            height: "124px",
            boxShadow: "2px 2px 20px rgba(0, 0, 0, 0.2)"
        }
    )
);

const ContentContainer = styled("div")(
    ({ theme }) => ({
        backgroundColor: "rgba(0, 0, 0, 0.7)",
        color: "white",
        fontWeight: "bold",
        position: "absolute",
        top: "205px",
        height: "105px",
        width: "100%",
        borderBottomLeftRadius: "16px",
        borderBottomRightRadius: "16px",
        boxShadow: "2px 2px 20px rgba(0, 0, 0, 0.2)"
    })
);

const ButtonsContainer = styled("div")(
    ({ theme }) => ({
        Width: "252px",
        minWidth: "252px",
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-end",
        marginTop: "36px",
    })
);


////////////////////////////////////////////////////////////////////////////

interface IProps {
    title: string;
    subtitle: string[];
    description: string;
    thumbnailUrl: string | null;
    defaultThumbnail: string;
    buttons: JSX.Element;
    onNavigate: () => void;
}


/**
 * Cabeçalho para dialog de Canais
 * @param props
 */
export const ChannelDialogInfo: React.FC<IProps> = (props) => {
    const { title, subtitle, description, thumbnailUrl, defaultThumbnail, buttons, onNavigate } = props;

    return (
        <MainContainer>
            <BackgroundImage
                imageUrl={thumbnailUrl == null ? defaultThumbnail : thumbnailUrl}
            />
            <MprcClickable onClick={onNavigate}>
                <BackgroundThumbnail
                    imageUrl={thumbnailUrl == null ? defaultThumbnail : thumbnailUrl}
                />
            </MprcClickable>

            <ContentContainer>
                <Grid container flexWrap="nowrap">
                    <Grid size="grow" padding={1} overflow="hidden">
                        <Stack spacing={1.5}>
                            <Stack direction="row" justifyContent="space-between" alignItems="center">
                                <Stack>
                                    <MprcClickable onClick={onNavigate}>
                                        <Typography variant="h1" color="white" noWrap>{title}</Typography>
                                    </MprcClickable>
                                    <Typography component="p" variant="caption" color="white" fontWeight="bold">
                                        <MprcJoinComponents
                                            components={subtitle}
                                            separator="&bull;"
                                        />
                                    </Typography>
                                </Stack>
                            </Stack>
                            <MprcTypographyOnDemand
                                variant="caption"
                                component="p"
                                color="white"
                                maxRows={2}
                            >
                                {description}
                            </MprcTypographyOnDemand>
                        </Stack>
                    </Grid>
                    <Grid>
                        <ButtonsContainer>
                            {buttons}
                        </ButtonsContainer>
                    </Grid>
                </Grid>
            </ContentContainer>
        </MainContainer>
    );
};
